import { render, staticRenderFns } from "./Collection.vue?vue&type=template&id=34ec365a&scoped=true&"
import script from "./Collection.vue?vue&type=script&lang=js&"
export * from "./Collection.vue?vue&type=script&lang=js&"
import style0 from "./Collection.vue?vue&type=style&index=0&id=34ec365a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ec365a",
  null
  
)

export default component.exports